import React, { useEffect, useState } from 'react';
import { VideoRatio16By9, ResponsiveVideoWrapper, ResponsiveVideoFrame, VideoEmbed } from './UiVideoPlayer.styles';
export function useVideoPlayer(videoId, videoProvider) {
  const [embed, setEmbed] = useState(null);
  useEffect(() => {
    switch (videoProvider) {
      case 'Loom':
        setEmbed( /*#__PURE__*/React.createElement(VideoRatio16By9, {
          "data-testid": "loom-video"
        }, /*#__PURE__*/React.createElement(ResponsiveVideoFrame, {
          src: `https://www.loom.com/embed/${videoId}`,
          frameBorder: "0",
          allowFullScreen: true,
          className: "loom_embed"
        })));
        return;

      case 'Wistia':
        const wistiaJsonp = document.createElement('script');
        wistiaJsonp.src = `//fast.wistia.com/embed/medias/${videoId}.jsonp`;
        wistiaJsonp.dataset['testid'] = 'wistia-jsonp';
        wistiaJsonp.async = true;
        const wistia = document.createElement('script');
        wistia.src = `//fast.wistia.com/assets/external/E-v1.js`;
        wistia.dataset['testid'] = 'wistia';
        wistia.async = true;
        document.body.append(wistiaJsonp, wistia);
        setEmbed( /*#__PURE__*/React.createElement(VideoRatio16By9, {
          className: "wistia_responsive_padding"
        }, /*#__PURE__*/React.createElement(ResponsiveVideoWrapper, {
          className: "wistia_responsive_wrapper"
        }, /*#__PURE__*/React.createElement(VideoEmbed, {
          className: `wistia_embed wistia_async_${videoId} seo=false videoFoam=true`
        }))));
        return () => {
          document.body.removeChild(wistiaJsonp);
          document.body.removeChild(wistia);
        };

      default:
        setEmbed( /*#__PURE__*/React.createElement("div", {
          "data-testid": "unsupported-video-provider"
        }, "Unsupported video provider"));
        return;
    }
  }, [videoId, videoProvider]);
  return {
    embed
  };
}